import { operatingIndustryToUrlSlug } from "@shared/operatingIndustryUrlSlug";

export const GUEST_DISCOVER_RETURN_TO = "/";

export {
  GUEST_EXPLORE_CORRIDORS_TAB,
  GUEST_EXPLORE_EXPERTS_TAB,
} from "@/pages/discover/discoverExplore.const";

/** Matches logged-in profile pages (`DISCOVER_LOGGED_IN` uses Container fluid). */
export const GUEST_DISCOVER_PROFILE_CONTAINER_SIZE = "100%" as const;

export function guestCorridorProfileHref(industry: string, headUserId: string): string {
  return `/discover/corridor/${operatingIndustryToUrlSlug(industry)}/${encodeURIComponent(headUserId)}`;
}

/** Corridor when both origin and target countries are set; otherwise cluster. */
export function guestCorridorProfileNavLabel(
  country?: string | null,
  targetCountry?: string | null,
): string {
  const from = country?.trim() ?? "";
  const to = targetCountry?.trim() ?? "";
  if (from && to) return "View Corridor";
  return "View Cluster";
}

export function guestExpertProfileHref(companyId: string): string {
  return `/discover/expert/company/${encodeURIComponent(companyId)}`;
}